/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `tcp` - TCP
 * * `udp` - UDP
 * @export
 */
export const ProtocolEnum = {
    Tcp: 'tcp',
    Udp: 'udp'
} as const;
export type ProtocolEnum = typeof ProtocolEnum[keyof typeof ProtocolEnum];


export function instanceOfProtocolEnum(value: any): boolean {
    for (const key in ProtocolEnum) {
        if (Object.prototype.hasOwnProperty.call(ProtocolEnum, key)) {
            if (ProtocolEnum[key as keyof typeof ProtocolEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProtocolEnumFromJSON(json: any): ProtocolEnum {
    return ProtocolEnumFromJSONTyped(json, false);
}

export function ProtocolEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtocolEnum {
    return json as ProtocolEnum;
}

export function ProtocolEnumToJSON(value?: ProtocolEnum | null): any {
    return value as any;
}

export function ProtocolEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ProtocolEnum {
    return value as ProtocolEnum;
}

